import React from "react";

const TopHeader = (props) => {
    return (
        <div style={{ height: 40 }} className="top-header">
            <div>
                <a href="mailto: infantindiapali@gmail.com">
                    <i className="fa fa-envelope-o"></i>{" "}
                    infantindiapali@gmail.com
                </a>
                <a href="href=tel:+919422693585">
                    <i className="fa fa-mobile" style={{ fontSize: 21 }}></i>{" "}
                    +91 94226 93585
                </a>
            </div>
            <div>
                <a href="https://www.facebook.com/Infant-India-193870490737877/">
                    <i className="fa fa-facebook"></i>
                </a>
            </div>
        </div>
    );
};

export default TopHeader;
